import { styled } from '@material-ui/core/styles'
import { Paper } from '@material-ui/core'

export const Content = styled(Paper)(({ theme: { breakpoints, spacing } }) => ({
  padding: spacing(),

  [breakpoints.up('sm')]: {
    padding: spacing(4),
  },
}))
